import request from "@utils/request";

const API_URL = "/addons/shop/api.";

export function goodsList(data) {
  return request.get(API_URL + "goods/lists", data, { login: false });
}

export function getGoodsDetail(data) {
  return request.get(API_URL + "goods/detail", data, { login: false });
}

export function getWxCode(data) {
  return request.post(API_URL + "goods/getWxCode", data, {
    login: false,
  });
}

export function allCategory(data) {
  return request.get(API_URL + "category/index", data, { login: false });
}
